import { useHomeSettings } from "@/hooks/useHomeSettings";
import { useContactSettings } from "@/hooks/useContactSettings";
import { Header } from "@/components/knmc/Header";
import { Hero } from "@/components/knmc/Hero";
import { Stats } from "@/components/knmc/Stats";
import { QuickAccess } from "@/components/knmc/QuickAccess";
import { FounderMessage } from "@/components/knmc/FounderMessage";
import { Departments } from "@/components/knmc/Departments";
import { Doctors } from "@/components/knmc/Doctors";
import { Packages } from "@/components/knmc/Packages";
import { Facilities } from "@/components/knmc/Facilities";
import { Testimonials } from "@/components/knmc/Testimonials";
import { SocialScroller } from "@/components/knmc/SocialScroller";
import { CtaBanner } from "@/components/knmc/CtaBanner";
import { Footer } from "@/components/knmc/Footer";
import { EmergencyBar } from "@/components/knmc/EmergencyBar";

export default function Index() {
  const { settings } = useHomeSettings();
  const { settings:contactSettings } = useContactSettings();
  return (
    <main className="min-h-screen bg-background">
      <Header overlay settings={settings?.header} phone={contactSettings?.phone} />
      <Hero slides={settings?.hero?.slides} emergencyPhone={contactSettings?.emergency_phone} />
      <Stats items={settings?.stats?.items} />
      <QuickAccess settings={settings?.quick_access} />
      <Departments settings={settings?.departments} />
      <FounderMessage settings={settings?.founder} />
      <Doctors settings={settings?.doctors} />
      <Packages settings={settings?.packages} />
      <Facilities settings={settings?.facilities} />
      <Testimonials />
      {/* <SocialScroller /> */}
      <CtaBanner phone={contactSettings?.phone} />
      <Footer />
      <EmergencyBar phone={contactSettings?.emergency_phone} />
    </main>
  );
}
